import template from './pdf.html';

export default angular
  .module('doxy.common.components.pdf', [])
  .directive('dPdf', function () {
    return {
      template,
      scope: {
        document: '=dDocument',
        details: '=dDetails',
        onDownload: '&dOnDownload'
      },
      restrict: 'E',
      controller: 'PdfController as pdf',
    };
  })
  .controller('PdfController', function ($scope, $injector, $timeout, Browser, $element) {
    $scope.isIPad = Browser.isIPad();
    import('vendor/pdf').then(
      ({ PDFJS, angularPdfViewerModule, workerSrc }) => {
        window.PDFJS = PDFJS;
        window.PDFJS.workerSrc = workerSrc;
        window.PDFJS.GlobalWorkerOptions.workerSrc = workerSrc;

        $injector.loadNewModules([angularPdfViewerModule]);
        $scope.pdfDelegate = function() {
          try {
            return $injector.get('pdfDelegate').$getByHandle('container');
          } catch (e) {
            // Delegate not yet available, return null
            return null;
          }
        };

        $timeout(() => {
          $scope.PDFJSLoaded = true;
          
          // Wait for DOM compilation and delegate registration
          // $evalAsync ensures this runs after the current digest cycle,
          // when the pdf-viewer element has been rendered
          $scope.$evalAsync(() => {
            const destroyDocumentLoadedWatcher = $scope.$watch(() => {
              const delegate = $scope.pdfDelegate();
              if (!delegate) return false;
              try {
                return delegate.getPageCount() > 0;
              } catch (e) {
                return false;
              }
            }, (loaded) => {
              if (Boolean(loaded)) {
                $scope.isDocumentLoaded = true;
                destroyDocumentLoadedWatcher();
              }
            });
          });
        }, 0);

        function scrollTop() {
          const wrapper = $element[0].querySelector('.pdf-viewer-wrapper');
          if (wrapper) {
            wrapper.scrollTop = 0;
          }
        }

        $scope.getPageCount = function() {
          const delegate = $scope.pdfDelegate();
          if (!delegate) return 0;
          try {
            return delegate.getPageCount();
          } catch (e) {
            return 0;
          }
        };

        $scope.onPrevClick = function() {
          const delegate = $scope.pdfDelegate();
          if (delegate) {
            delegate.prev();
            scrollTop();
          }
        };

        $scope.onNextClick = function() {
          const delegate = $scope.pdfDelegate();
          if (delegate) {
            delegate.next();
            scrollTop();
          }
        };

      }
    );
  })
  .directive('dPdfCurrentPage', function () {
    return {
      restrict: 'A',
      scope: {
        model: '=ngModel',
        pdfDelegate: '&dPdfDelegate',
      },
      link: function (scope) {
        scope.$watch(
          function () {
            const pdfDelegate = scope.pdfDelegate();
            if (!pdfDelegate) return;
            try {
              return pdfDelegate.getCurrentPage();
            } catch (e) {
              return;
            }
          },
          function (newValue) {
            if (newValue !== undefined) {
              scope.model = newValue;
            }
          }
        );

        scope.$watch('model', function (newValue) {
          const pdfDelegate = scope.pdfDelegate();
          const num = parseInt(newValue);
          scope.model = num;
          if (!num || !pdfDelegate) {
            return;
          }
          
          try {
            if (pdfDelegate.getCurrentPage() === num) {
              return;
            }

            const max = pdfDelegate.getPageCount();
            if (num < 1) {
              scope.model = 1;
            } else if (num > max) {
              scope.model = max;
            } else {
              pdfDelegate.goToPage(num);
            }
          } catch (e) {
            // Delegate methods not yet available, ignore
          }
        });
      },
    };
  }).name;
